import {
	performDeleteRequest,
	performPostRequest,
	performPutRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	getCmdbAvatarCreateTmpFilesUrl,
	getCmdbAvatarDeleteUrl,
	getCmdbAvatarUploadUrl,
} from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/avatar.tsx';
import { getCmdbObjectByIdAvatarUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/object.tsx';
import type {
	CmdbObjectTypeId,
	CmdbObjectId,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type {
	CreateTempAvatarResponse,
	AvatarUploadResponse,
	AttachObjectAvatarResponse,
} from './types.tsx';

type AvatarService = {
	uploadAvatar: (arg1: { workspaceId: string; body: FormData }) => Promise<AvatarUploadResponse>;
	attachObjectAvatar: (arg1: {
		workspaceId: string;
		objectId: string;
		avatarUUID: string;
	}) => Promise<AttachObjectAvatarResponse>;
	detachObjectAvatar: (arg1: { workspaceId: string; objectId: CmdbObjectId }) => Promise<void>;
	createTempObjectAvatar: (arg1: {
		workspaceId: string;
		objectKey: string;
	}) => Promise<CreateTempAvatarResponse>;
	deleteObjectAvatar: (arg1: {
		workspaceId: string;
		avatarUUID: string;
		objectTypeId: CmdbObjectTypeId;
	}) => Promise<void>;
};

export const ObjectAvatarService: AvatarService = {
	uploadAvatar: ({ workspaceId, body }) =>
		performPostRequest(getCmdbAvatarUploadUrl(workspaceId), {
			headers: {},
			body,
		}),

	attachObjectAvatar: ({ workspaceId, objectId, avatarUUID }) =>
		performPutRequest(getCmdbObjectByIdAvatarUrl(workspaceId, objectId), {
			headers: {
				'content-type': 'application/json',
			},
			body: JSON.stringify({ avatarUUID }),
		}),

	detachObjectAvatar: ({ workspaceId, objectId }) =>
		performDeleteRequest(getCmdbObjectByIdAvatarUrl(workspaceId, objectId)),

	createTempObjectAvatar: ({ workspaceId, objectKey }) =>
		performPostRequest(getCmdbAvatarCreateTmpFilesUrl(workspaceId), {
			body: JSON.stringify({ objectKey }),
		}),

	deleteObjectAvatar: ({ workspaceId, avatarUUID, objectTypeId }) =>
		performDeleteRequest(getCmdbAvatarDeleteUrl(workspaceId, avatarUUID, { objectTypeId })),
};
